var email = "https://shopfront-cdn.tekoapis.com/static/22f44138cac1453a.svg";

export { email as default };
